import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import CountUp from '../components/CountUp';
import './Brands.css';

function Brands() {
  const [openFaq, setOpenFaq] = useState(null);

  const creatorHandles = [
    { handle: '@chucksflavortrain', url: 'https://www.instagram.com/chucksflavortrain/', avatar: '/avatars/chucksflavortrain.jpg' },
    { handle: '@richardeats_', url: 'https://www.instagram.com/richardeats_/', avatar: '/avatars/richardeats_.jpg' },
    { handle: '@alexrioscooks', url: 'https://www.instagram.com/alexrioscooks/', avatar: '/avatars/alexrioscooks.jpg' },
    { handle: '@chilipeppercooks', url: 'https://www.instagram.com/chilipeppercooks/', avatar: '/avatars/chilipeppercooks.jpg' },
    { handle: '@meatlicious', url: 'https://www.instagram.com/meatlicious/', avatar: '/avatars/meatlicious.jpg' },
    { handle: '@luifern', url: 'https://www.instagram.com/luifern/', avatar: '/avatars/luifern.jpg' },
    { handle: '@fireman1231_', url: 'https://www.instagram.com/fireman1231_/', avatar: '/avatars/fireman1231_.jpg' },
    { handle: '@marriedtobbq', url: 'https://www.instagram.com/marriedtobbq/', avatar: '/avatars/marriedtobbq.jpg' },
    { handle: '@girlgonegrilling', url: 'https://www.instagram.com/girlgonegrilling/', avatar: '/avatars/girlgonegrilling.jpg' },
    { handle: '@_devontewest', url: 'https://www.instagram.com/_devontewest/', avatar: '/avatars/_devontewest.jpg' },
  ];

  const stats = [
    { value: 135, suffix: 'm+', label: 'Talent Audience' },
    { value: 70, suffix: '', label: 'Creators Represented', },
    { value: 2, suffix: 'b+', label: 'Client Monthly Views', },
    { value: 10, prefix: '$', suffix: 'm+', label: 'Paid to Talent' },
    { value: 1500, suffix: '+', label: 'Brand Campaigns', },
  ];

  const brands = [
    { name: 'Pepsi', domain: 'pepsi.com' },
    { name: 'Hulu', domain: 'hulu.com' },
    { name: 'TCL', domain: 'tcl.com' },
    { name: 'Ninja Kitchen', domain: 'ninjakitchen.com', localLogo: '/logos/ninja.jpeg' },
    { name: 'Kraft', domain: 'kraftheinzcompany.com' },
    { name: 'KFC', domain: 'kfc.com' },
    { name: 'McCormick', domain: 'mccormick.com' },
    { name: 'Lifeway Foods', domain: 'lifeway.com' },
    { name: 'B&G Foods', domain: 'bgfoods.com' },
    { name: 'Virgin Voyages', domain: 'virgin.com' },
    { name: 'Dawn', domain: 'dawn-dish.com' },
    { name: 'Dairy MAX', domain: 'dairymax.org' },
    { name: 'SkipTheDishes', domain: 'skipthedishes.com' },
    { name: "Bush's Beans", domain: 'bushbeans.com' },
    { name: '49ers', domain: 'sf49ers.com' },
    // Row 4
    { name: "Hellmann's", domain: 'hellmanns.com', localLogo: '/logos/hellmanns.png' },
    { name: 'DoorDash', domain: 'doordash.com' },
    { name: 'Meta', domain: 'meta.com' },
    { name: 'Amazon', domain: 'amazon.com' },
    { name: 'Disney', domain: 'disney.com' },
  ];

  const caseStudies = [
    {
      title: 'Hay Day',
      desc: 'A creator-led campaign born from a big brand moment.',
      image: '🎮'
    },
    {
      title: 'Unmeat',
      desc: 'A bespoke creator competition designed for impact.',
      image: '🌱'
    },
    {
      title: 'Toom',
      desc: 'Consistent creator content with platform-native execution.',
      image: '🛠️'
    },
    {
      title: 'Turkish Airlines',
      desc: 'A multi-trip creator campaign blending culture, cuisine, and content at scale.',
      image: '✈️'
    },
  ];

  const partnerships = [
    {
      creator: 'Christopher Smith',
      brand: 'KFC',
      url: 'https://www.instagram.com/reels/DRzv_gKEVOF/'
    },
    {
      creator: 'Chuck Matto',
      brand: 'Jack Daniels',
      url: 'https://www.instagram.com/p/DP1fqebkbpR/'
    },
    {
      creator: 'Alex Rios',
      brand: 'Pepsi',
      url: 'https://www.instagram.com/p/DSau4GcEs-u/'
    },
    {
      creator: 'Katherine Salom',
      brand: 'DoorDash',
      url: 'https://www.instagram.com/reel/DKh7TdwuWvF/'
    },
  ];

  const benefits = [
    {
      icon: '🎯',
      title: 'Campaign Strategy & Vision',
      desc: 'We assist with crafting your objectives into tailored, platform-ready content that truly resonates with audiences.'
    },
    {
      icon: '🤝',
      title: 'Comprehensive Creator Representation',
      desc: 'Our team manages every phase—from talent selection to content delivery—ensuring smooth and effective collaboration.'
    },
    {
      icon: '📈',
      title: 'Measurable Impact',
      desc: 'We deliver transparent, insights-driven reporting that tracks reach, engagement, and tangible outcomes.'
    },
    {
      icon: '✨',
      title: 'Live Experiences & Activations',
      desc: 'Bring campaigns to life with carefully curated, creator-led events designed to make a lasting impression.'
    },
    {
      icon: '📝',
      title: 'Simplified Agreements',
      desc: 'We handle contracts and compliance efficiently, keeping every partnership secure, seamless, and brand-safe.'
    },
    {
      icon: '🚀',
      title: '360° Campaign Delivery',
      desc: 'From ideation to execution, we oversee every step to guarantee precise and impactful campaign results.'
    },
  ];

  const talentHandles = [
    '@lionfieldmusic', '@itsqcp', '@louisgcooks', '@kianhiatt',
    '@lionfieldmusic', '@itsqcp', '@louisgcooks', '@kianhiatt'
  ];

  const faqs = [
    {
      q: 'How does Alooma manage contracts and compliance?',
      a: 'We streamline all contracting on your behalf. Instead of drafting multiple agreements with each creator, we manage a single SOW-based contract with you and handle individual creator agreements internally. We support redlining, legal reviews, and ensure all terms — including usage rights and disclosures — are brand-safe, compliant, and fast-tracked.'
    },
    {
      q: 'Can we work with creators outside of your network?',
      a: 'Yes. While we have a strong internal roster, we can also source and onboard external creators based on your brief — all under our management.'
    },
    {
      q: 'How quickly can a campaign go live?',
      a: 'We can move as fast as our partners can. Whether you\'re looking for a quick turnaround or planning long-term, we\'re built for speed.'
    },
    {
      q: 'Do you offer strategy or just talent execution?',
      a: 'We do both. From creative development to end-to-end execution, our team can build campaigns from scratch or plug into existing plans.'
    },
    {
      q: 'How do you measure performance?',
      a: 'We track viewership, engagement, and conversion, providing clear, data-backed reporting for every campaign.'
    },
    {
      q: 'Where are you based and what regions do you cover?',
      a: 'We\'re headquartered in Los Angeles with international team members, and we operate across North America, South America, and Europe. We\'re always open to expanding into new regions.'
    },
  ];

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  return (
    <div className="brands-page">
      {/* Hero Section */}
      <section className="brand-hero">
        <div className="brand-hero-bg">
          <div className="hero-gradient"></div>
          <div className="hero-particles"></div>
        </div>

        {/* Creator Handles Floating */}
        <div className="floating-handles">
          {creatorHandles.map((creator, index) => (
            <a
              key={index}
              href={creator.url}
              target="_blank"
              rel="noopener noreferrer"
              className="floating-handle"
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              {creator.avatar && (
                <div className="handle-avatar">
                  <img
                    src={creator.avatar}
                    alt={creator.handle}
                  />
                </div>
              )}
              <span className="handle-text">{creator.handle}</span>
            </a>
          ))}
        </div>

        <div className="brand-hero-content">
          <span className="hero-label">For Brands</span>
          <h1 className="hero-headline">
            Drive Genuine Connection.<br />
            <span className="accent">Foster Impactful Results.</span>
          </h1>
          <p className="hero-subtext">
            Alooma brings brands together with a handpicked roster of creators who spark
            genuine engagement and turn ideas into conversations that matter.
          </p>
          <Link to="/contact" className="hero-cta">
            Contact Us
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </Link>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="stats-container">
          {stats.map((stat, index) => (
            <div key={index} className="stat-item">
              <span className="stat-value">
                <CountUp
                  end={stat.value}
                  prefix={stat.prefix || ''}
                  suffix={stat.suffix || ''}
                  decimals={stat.decimals || 0}
                  duration={2500}
                />
              </span>
              <span className="stat-label">{stat.label}</span>
              <span className="stat-sub">{stat.sub}</span>
            </div>
          ))}
        </div>
      </section>

      {/* Case Studies Section - TEMPORARILY HIDDEN
      <section className="case-studies-section">
        <div className="section-container">
          <span className="section-label">Case Studies</span>
          <h2 className="section-headline">
            Proven Partnerships. <span className="accent">Real Results.</span>
          </h2>
          <p className="section-subtext">
            Explore how leading brands have teamed up with our creators to build iconic 
            campaigns — from global travel shoots to viral cooking competitions.
          </p>
          <div className="case-studies-grid">
            {caseStudies.map((study, index) => (
              <div key={index} className="case-study-card">
                <div className="case-study-image">
                  <span className="case-study-emoji">{study.image}</span>
                  <div className="case-study-overlay">
                    <span className="view-text">View Case Study</span>
                  </div>
                </div>
                <div className="case-study-content">
                  <h3>{study.title}</h3>
                  <p>{study.desc}</p>
                </div>
                <button className="case-study-view">View →</button>
              </div>
            ))}
          </div>
        </div>
      </section>
      */}

      {/* Brands Logo Section */}
      <section className="brands-logo-section">
        <div className="section-container">
          <span className="section-label">Brands</span>
          <h2 className="section-headline">
            Endorsed by the World's <span className="accent">Top Brands.</span>
          </h2>
          <p className="section-subtext">
            When the culinary/food, lifestyle, and entertainment industries need top-tier talent,
            they come to Alooma. We connect elite creators with campaigns that deliver impact,
            tell powerful stories, and set the standard every time.
          </p>
          <div className="brands-logos-grid">
            {brands.map((brand, index) => (
              <div key={index} className="brand-logo-item">
                <div className="brand-logo-wrapper">
                  <img
                    src={brand.localLogo || `https://img.logo.dev/${brand.domain}?token=pk_X-1ZO13GSgeOoUrIuJ6GMQ&size=400&format=png`}
                    alt={brand.name}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.style.opacity = '0';
                    }}
                  />
                </div>
                <span className="brand-name">{brand.name}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Strategic Partnerships Section */}
      <section className="partnerships-section">
        <div className="section-container">
          <span className="section-label">Partnerships</span>
          <h2 className="section-headline">
            Strategic <span className="accent">Partnerships.</span>
          </h2>
          <div className="partnerships-grid">
            {partnerships.map((partnership, index) => (
              <a
                key={index}
                href={partnership.url}
                target="_blank"
                rel="noopener noreferrer"
                className="partnership-card"
              >
                <div className="partnership-content">
                  <h3>{partnership.creator} <span className="partnership-x">×</span> {partnership.brand}</h3>
                </div>
                <span className="partnership-link">View on Instagram →</span>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section">
        <div className="section-container">
          <h2 className="section-headline">
            Why Brands <span className="accent">Choose Alooma.</span>
          </h2>
          <p className="section-subtext">
            We deliver elite creators, seamless execution, and campaigns that actually perform. Brands come to Alooma for talent that drives impact, not just impressions.
          </p>
          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="benefit-card">
                <div className="benefit-number">{String(index + 1).padStart(2, '0')}</div>
                <h3>{benefit.title}</h3>
                <p>{benefit.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Media Kits Section */}
      <section className="media-kits-section">
        <div className="section-container">
          <h2 className="section-headline">
            Discover Our <span className="accent">Creators.</span>
          </h2>
          <p className="section-subtext">
            Our network spans category leaders and high-growth creators alike. Review media kits and connect with talent built to elevate your campaign.
          </p>
        </div>
        <div className="roster-iframe-container">
          <iframe
            src="https://july.bio/alooma"
            title="Alooma Creator Roster"
            className="roster-iframe"
          />
        </div>
      </section>

      {/* FAQ Section - TEMPORARILY HIDDEN
      <section className="faq-section">
        <div className="section-container">
          <span className="section-label">FAQ</span>
          <h2 className="section-headline">
            Frequently Asked <span className="accent">Questions.</span>
          </h2>
          <p className="section-subtext">
            From contracting to campaign execution, here are the answers to the most common
            questions brands ask when working with us.
          </p>
          <div className="faq-list">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className={`faq-item ${openFaq === index ? 'open' : ''}`}
                onClick={() => toggleFaq(index)}
              >
                <div className="faq-question">
                  <span>{faq.q}</span>
                  <span className="faq-toggle"></span>
                </div>
                <div className="faq-answer">
                  <div className="faq-answer-inner">
                    <p>{faq.a}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      */}

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-container">
          <span className="section-label">Get Started</span>
          <h2 className="cta-headline">Collaborate With Us.</h2>
          <p className="cta-subtext">
            We’re seeking creators who stand out and bring unique perspectives. Get in touch, and let’s explore how we can make something great happen together.
          </p>
          <Link to="/contact" className="cta-button-large">
            Contact Us
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="brand-footer">
        <div className="footer-content">
          <p>©2025 ALOOMA. All rights reserved.</p>
          <div className="footer-socials">
            <a href="https://www.instagram.com/aloomamediagroup/" target="_blank" rel="noopener noreferrer" className="footer-social-link">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
              </svg>
              Instagram
            </a>
            <a href="https://www.linkedin.com/company/alooma-media-group/" target="_blank" rel="noopener noreferrer" className="footer-social-link">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
              </svg>
              LinkedIn
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Brands;
